import { HttpParams } from '@angular/common/http';

export class BdAdministrativeDistrictFilter {
  constructor(public q: string = '') {}

  public toHttpParams(): HttpParams {
    let params = new HttpParams();

    params = params.append('q', this.q);

    return params;
  }
}
